module.exports = __webpack_public_path__ + "static/img/yinliao.3e7a661e.svg";